import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'gender-neutrois', 'GenderNeutrois', [["path",{"d":"M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10"}],["path",{"d":"M12 10v-7"}]]);